import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3 flex-1 flex align-middle items-center overflow-hidden" }
const _hoisted_2 = { class: "truncate" }


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Boolean,
    default: undefined,
  },
  label: {
    type: String,
    default: undefined,
  },
  headerClass: {
    type: String,
    default: undefined,
  },
},
  emits: ['update:modelValue'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    "header-class": __props.headerClass,
    class: "c-expansion-item"
  }, {
    header: _withCtx(() => [
      _createVNode(_component_q_checkbox, _mergeProps({ "model-value": __props.modelValue }, _ctx.$inri.checkbox, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      }), null, 16, ["model-value"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1)
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["header-class"]))
}
}

})